module.exports = __webpack_public_path__ + "assets/e29c7c2587c5cdf14fbdf934310d3da2.mp3";